import { message as $message } from 'antd'
import {
    queryAutoExtendSettings,
    saveAutoExtendSettings,
    autoPromoteNewItem,
} from '@/services/distribute/myDistributeMall'
import styles from '../modules/distribute/components/AutoExtendSetModal/index.less'

export default {
    namespace: 'partnerShop',
    state: {
        autoPromoteNewGoods: false,
        autoPromoteNewGoodsLoaded: false,
    },
    effects: {
        *queryAutoPromoteNewGoods(_, { call, put }) {
            // 不做缓存，新开tab的场景比较多

            try {
                const { success, message, data } = yield call(queryAutoExtendSettings)

                if (success) {
                    yield put({
                        type: 'update',
                        payload: {
                            autoPromoteNewGoods: data,
                            autoPromoteNewGoodsLoaded: true,
                        },
                    })
                } else {
                    $message.error(message)
                }
            } catch (e) {
                console.error('catchError', e)
            }
        },
        *modifyAutoPromoteNewGoods({ payload }, { call, put }) {
            try {
                const { success, message } = yield call(saveAutoExtendSettings, payload)

                if (success) {
                    yield put({
                        type: 'update',
                        payload: {
                            autoPromoteNewGoods: payload.autoPromoteNewGoods,
                        },
                    })

                    if (payload.autoPromoteNewGoods) {
                        const res = yield call(autoPromoteNewItem)

                        if (res.success) {
                            const { newNum, hasNewItem, todayAutoPromote } = res.data || {}
                            if (todayAutoPromote) {
                                $message.warn('今日已自动推广过商品，后续每天凌晨自动推广')
                            } else if (newNum) {
                                $message.success({
                                    key: 'autoExtend',
                                    content: `自动推广商品${newNum}`,
                                    className: styles.message,
                                })
                            } else {
                                const msg = hasNewItem
                                    ? '今日已经推广了100个新品（每天最多推广100个），明天凌晨系统会再次自动推广'
                                    : '没有可推广的新品，明天凌晨系统会再次自动推广'
                                $message.warn(msg)
                            }

                            return
                        } else {
                            $message.error(res.message)
                        }
                    } else {
                        return
                    }
                } else {
                    $message.error(message)
                }
            } catch (e) {
                console.error('catchError', e)
            }

            return Promise.reject(new Error('modifyAutoPromoteNewGoods error'))
        },
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
    },
}
